import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { OrdinaryQuery, OrdinaryAlgorithm } from "private-angular-vhframeworks"
import {
  Validators,
  FormBuilder,
  FormGroup,
  FormControl
} from "@angular/forms";
import { isIndexedAccessTypeNode } from 'typescript';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit {
  @ViewChild("form_chat") form: ElementRef;
  start_chat: boolean = false;
  icon: any = "chat"
  chat_form: FormGroup
  message: any = "";
showdri:boolean;
  listMessage: any;

  constructor(
    private ordinaryquery: OrdinaryQuery, 
    private formBuilder: FormBuilder, 
    private ordinaryAlgorithm: OrdinaryAlgorithm,
    private platform: Platform
  ) {
    this.isDesktop();
    
  }

  ngOnInit(): void {
    this.checkUser();
  }
clickshow(){
  this.showdri=!this.showdri
}
  isDesktop() {
    if (this.platform.is("desktop") || this.platform.is("mobile"))
    this.showdri = false
  else
    this.showdri = true
}
  initForm(user: any = {}) {
    this.chat_form = this.formBuilder.group({
      name: new FormControl(user.name ? user.name : ""),
      email: new FormControl(
        user.email ? user.email : "",
        Validators.compose([
          Validators.required,
          Validators.email,
        ])
      ),
      phone: new FormControl(
        user.phone ? user.phone : "",
        Validators.compose([Validators.minLength(5), Validators.required])
      )
    })
  }

  async formConfirm() {
    await localStorage.setItem("vhChat", JSON.stringify(this.chat_form.value))
    this.checkUser()
  }

  showForm() {
    if (this.icon == "chat") {
      // this.form.nativeElement.style.display="flex";
      this.form.nativeElement.style.opacity = "1";
      this.form.nativeElement.style.transition = "all 0.2s";
      this.form.nativeElement.style.transform = "scale(1)"
      this.icon = "close";
      this.clickshow();
    }
    else {
      // this.form.nativeElement.style.display="none";
      this.form.nativeElement.style.opacity = "0";
      this.form.nativeElement.style.transform = "scale(0)"
      this.form.nativeElement.style.transition = "all 0.2s";
      this.icon = "chat";
    }

  }

  checkUser() {
    if (localStorage.getItem("vhChat")) {
      this.initForm(JSON.parse(localStorage.getItem("vhChat")))
      this.start_chat = true;
    } else {
      this.initForm();
    }

    this.callBackMessage({ email: this.chat_form.value['email'], phone: this.chat_form.value['phone'] })
  }

  callBackMessage(user) {
    this.ordinaryquery.callbackMessages_USER(async messages => {
      
      if (!messages.empty) {
        this.listMessage = await messages.docs.reverse().map(item => {
          return { id: item.id, ...item.data(), dateOn: false }
        });
        
        this.ordinaryAlgorithm.waitingStack().then(() => this.scrollBottom())
      }
    }, user, 100)
  }

  index: any = 0;
  send(event) {
    if (event.keyCode == 13) {
      if (!this.index) this.sendChat()
      this.index += 1;
    }
  }

  sendChat() {
    this.ordinaryquery.sendMessage_USER({ email: this.chat_form.value.email, phone: this.chat_form.value.phone, message: this.message }).then((res: any) => {
      this.message = '';
      
      this.index = 0;
    })
  }

  scrollBottom() {
    document.getElementById("body_chat").scrollTop = document.getElementById("body_chat").scrollHeight
  }
}
